export default {
    data() {
        return {
            clients: ['telekom.png','aerticket.png', 'bde.png', 'ceu.png', 'comunidad-madrid.png', 'dkultura.png', 'gobierno-navarra.png', 'uji.jpg'],
        }
    }
};